import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { NgForm, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

import { EditWebcastBaseSettingsComponent } from './EditWebcastBaseSettings.Component';
import { EditWebcastModel } from './EditWebcastModel';
import { IEditSpeakerProfile } from '../webcast/WebcastBranding';

import styles from './EditWebcast.module.less';

@Component({
	selector: 'edit-speaker-profiles',
	templateUrl: './EditSpeakerProfiles.Component.html',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => EditSpeakerProfilesComponent),
		multi: true
	}],
	standalone: false
})
export class EditSpeakerProfilesComponent extends EditWebcastBaseSettingsComponent {
	@Input() public webcast: EditWebcastModel;

	@ViewChild(NgForm) public form: NgForm;

	public readonly styles = styles;
	public readonly maxSpeakers = 20;

	public get addEnabled() {
		const speakers = this.webcast.brandingSettings.speakerProfiles;
		const first = speakers[0];
		return speakers.length < this.maxSpeakers && (
			!first ||
			!first.isNew ||
			!first.isEdit);
	}

	public startEdit(speaker: IEditSpeakerProfile): void {
		speaker.edits = { ...speaker.data };
		speaker.isEdit = true;
		this.validateFn();
	}

	public applyEdits(speaker: IEditSpeakerProfile) {
		speaker.data = { ...speaker.edits };
		delete speaker.edits;
		speaker.isEdit = false;
		speaker.isNew = false;
		this.validateFn();
	}

	public cancelEdit(speaker: IEditSpeakerProfile, index: number): void {
		if(speaker.isNew) {
			this.remove(index);
			return;
		}

		delete speaker.edits;
		speaker.isEdit = false;
		this.validateFn();
	}

	public add(): void {
		this.webcast.brandingSettings.speakerProfiles.unshift({
			isEdit: true,
			isNew: true,
			edits: {} as any,
			data: {} as any
		});
	}

	public remove(index: number): void {
		this.webcast.brandingSettings.speakerProfiles.splice(index, 1);
	}

	public validate(): ValidationErrors {
		if(this.webcast.brandingSettings.speakerProfiles.some(s => s.isEdit)) {
			return { hasEdits: true };
		}
		return super.validate();
	}

}
